// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__cBdNF","header":"PatientBlock_header__3wIcX","label":"PatientBlock_label__39DR6","option":"PatientBlock_option__3zD8B"};